import { useEffect } from 'react';
import { SURVEYS } from '@hotjar/webapp/constants/routes';
import type { SurveyListItem } from '@hotjar/feedback/domain/Surveys/Survey/Survey';
import { useNavigate } from 'react-router';
import { getRoute } from '@hotjar/webapp/utils/routing';
import { useSurveyWidgetsQuery } from '../../../../domain/Surveys/query';

interface ResponseViewRoutingProps {
  siteId: number | undefined;
  surveyId: number | undefined;
  enabled: boolean;
}

function hasMoreThanThreeWidgetsInCategory(widgets: SurveyListItem[]) {
  const activeWidgets = widgets.filter(({ enabled }) => enabled).length;
  return activeWidgets > 3 || widgets.length - activeWidgets > 3;
}

export const useResponsesViewRouting = ({
  siteId,
  surveyId,
  enabled,
}: ResponseViewRoutingProps): void => {
  const { data: widgets } = useSurveyWidgetsQuery(siteId);
  const navigate = useNavigate();

  useEffect(() => {
    if (!enabled || widgets === undefined || siteId === undefined || surveyId === undefined) return;

    if (hasMoreThanThreeWidgetsInCategory(widgets)) {
      navigate(getRoute(SURVEYS.LIST.path, { siteId }), {
        replace: true,
      });
      return;
    }

    navigate(getRoute(SURVEYS.RESPONSES.path, { siteId, surveyId }), {
      replace: true,
    });
  }, [widgets, surveyId, siteId, navigate, enabled]);
};
